var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftWithLine(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41678 11.5C6.66086 11.256 6.66086 10.8602 6.41678 10.6162L1.80039 5.99977L6.41678 1.38338C6.66086 1.1393 6.66086 0.743574 6.41678 0.499497C6.1727 0.25542 5.77697 0.25542 5.53289 0.499497L0.474562 5.55783C0.357352 5.67504 0.291504 5.83401 0.291504 5.99977C0.291504 6.16553 0.357352 6.3245 0.474562 6.44171L5.53289 11.5C5.77697 11.7441 6.1727 11.7441 6.41678 11.5Z",
    fill: "#1F2328"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.433105 6C0.433105 6.34518 0.712928 6.625 1.05811 6.625L15.0831 6.625C15.4283 6.625 15.7081 6.34518 15.7081 6C15.7081 5.65482 15.4283 5.375 15.0831 5.375L1.05811 5.375C0.712928 5.375 0.433105 5.65482 0.433105 6Z",
    fill: "#1F2328"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWithLine);
export default __webpack_public_path__ + "static/media/arrow-left-with-line.352271c854472669cd753b917ce0224b.svg";
export { ForwardRef as ReactComponent };